import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import Menu from "../components/menu.js";
import Navbar from "../components/navbar.js";
import Footer from "../components/footer.js";
function Price(){
    useEffect(() => {
            document.title = "Pricing | AA_Digitals"; // Change title
        }, []);
    return(
<Fragment>
<header class="header-one sticky-header">
<Menu></Menu>
<Navbar></Navbar>
    </header>
   
    <section class="breadcrumb-section bgc" style={{backgroundImage: "url(assets/img/bread2.jpg)"}}>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-7">
                    <div class="breadcrumb-text">
                        <span class="title-tag">Welcome to our company</span>
                        <h2 class="page-title">Price and plans.</h2>
                    </div>
                </div>
                <div class="col-lg-6 col-md-5">
                    <div class="breadcrumb-nav">
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li class="separator">|</li>
                            <li>Pricing</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
   



    <section class="pricing-section section-gap">
        <div class="container">
            <div class="section-title text-center mb-30">
                <span class="title-tag1">Branding</span>
                <h2 class="title1">Price & Plans</h2>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-4 col-md-6 col-sm-10">
                    <div class="pricing-plan-box mt-30">
                        <div class="pricing-header">
                            
                            <div class="text-end">
                                <span class="price-wrap">
                                    <center>
                                        <span><p style={{fontSize:"48px",color:"black"}}>Basic</p></span>
                                    <div></div>
                                    </center>
                                    <span class="currency">Rs</span>
                                    <span class="price">50,000</span>
                                    <span class="price-suffix">.00</span>
                                </span>
                                <span class="pricing-limit">Per Month</span>
                            </div>
                        </div>
                        <div class="pricing-content">
                            <ul class="clearfix">
                                <li>Digital account creation <i class="fal fa-check"></i></li>
                                <li>⁠social media setup <i class="fal fa-check"></i></li>
                                <li>Static website <i class="fal fa-check"></i></li>
                                <li>⁠Logo Design<i class="fal fa-check"></i></li>
                                <li>⁠plan for business<i class="fal fa-check"></i></li>
                                <li>⁠google my business setup<i class="fal fa-check"></i></li>
                                <li>Product Shoot<i class="fal fa-check"></i></li>
                                
                                
                            </ul>
                            <Link to="/contact" class="main-btn main-btn-3">Purchase Now</Link>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6 col-sm-10">
                    <div class="pricing-plan-box featured-box mt-30">
                        <div class="pricing-header">
                            
                            <div class="text-end">
                                <span class="price-wrap">
                                    <center>
                                        <span><p style={{fontSize: "48px", color:" rgb(68, 68, 151)"}}>Standard</p></span>
                                    <div></div>
                                    </center>
                                    <span class="currency">Rs</span>
                                    <span class="price">60,000</span>
                                    <span class="price-suffix">.00</span>
                                </span>
                                <span class="pricing-limit">Per Month</span>
                            </div>
                        </div>
                        <div class="pricing-content">
                            <ul class="clearfix">
                                <li>Digital account creation <i class="fal fa-check"></i></li>
                                <li>⁠account setup <i class="fal fa-check"></i></li>
                                <li>Semi-Dynamic website <i class="fal fa-check"></i></li>
                                <li>⁠Logo Design<i class="fal fa-check"></i></li>
                                <li>⁠plan for business<i class="fal fa-check"></i></li>
                                <li>⁠google my business setup<i class="fal fa-check"></i></li>
                                <li>Product Shoot <i class="fal fa-check"></i></li>
                                
                                
                            </ul>
                            <Link to="/contact" class="main-btn main-btn-3">Purchase Now</Link>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6 col-sm-10">
                    <div class="pricing-plan-box mt-30">
                        <div class="pricing-header">
                            
                            <div class="text-end">
                                <span class="price-wrap">
                                    <center>
                                        <span><p style={{fontSize: "48px", color: "red"}}>Premium</p></span>
                                    <div></div>
                                    </center>
                                    <span class="currency">Rs</span>
                                    <span class="price">80,000</span>
                                    <span class="price-suffix">.00</span>
                                </span>
                                <span class="pricing-limit">Per Month</span>
                            </div>
                        </div>
                        <div class="pricing-content">
                            <ul class="clearfix">
                                <li>Digital account creation <i class="fal fa-check"></i></li>
                                <li>⁠account setup <i class="fal fa-check"></i></li>
                                <li>Ecommerce website<i class="fal fa-check"></i></li>
                                <li>⁠Logo Design<i class="fal fa-check"></i></li>
                                <li>⁠plan for business<i class="fal fa-check"></i></li>
                                <li>⁠google my business setup<i class="fal fa-check"></i></li>
                                <li>Product Shoot <i class="fal fa-check"></i></li>
                                <li>Video Shoot <i class="fal fa-check"></i></li>
                                
                            </ul>
                            <Link to="/contact" class="main-btn main-btn-3">Purchase Now</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="pricing-section section-gap">
        <div class="container">
            <div class="section-title text-center mb-30">
                <span class="title-tag1">Social Media</span>
                <h2 class="title1">Price & Plans</h2>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-4 col-md-6 col-sm-10">
                    <div class="pricing-plan-box mt-30">
                        <div class="pricing-header">
                            
                            <div class="text-end">
                                <span class="price-wrap">
                                    <center>
                                        <span><p style={{fontSize: "48px", color:"black;"}}>Basic</p></span>
                                    <div></div>
                                    </center>
                                    <span class="currency">Rs</span>
                                    <span class="price">15,000</span>
                                    <span class="price-suffix">.00</span>
                                </span>
                                <span class="pricing-limit">Per Month</span>
                            </div>
                        </div>
                        <div class="pricing-content">
                            <ul class="clearfix">
                                <li>11 Poster Design <i class="fal fa-check"></i></li>
                                <li>4 Reels <i class="fal fa-check"></i></li>
                                <li>Product Shoot(additional charges) <i class="fal fa-check"></i></li>
                                
                            </ul>
                            <Link to="/contact" class="main-btn main-btn-3">Purchase Now</Link>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6 col-sm-10">
                    <div class="pricing-plan-box featured-box mt-30">
                        <div class="pricing-header">
                            
                            <div class="text-end">
                                <span class="price-wrap">
                                    <center>
                                        <span><p style={{fontSize: "48px", color:" rgb(68, 68, 151)"}}>Standard</p></span>
                                    <div></div>
                                    </center>,
                                    <span class="currency">Rs</span>
                                    <span class="price">25,000</span>
                                    <span class="price-suffix">.00</span>
                                </span>
                                <span class="pricing-limit">Per Month</span>
                            </div>
                        </div>
                        <div class="pricing-content">
                            <ul class="clearfix">
                                <li>12 Poster Design <i class="fal fa-check"></i></li>
                                <li>8 Reels <i class="fal fa-check"></i></li>
                                <li>Product Shoot (Few complementary shoot) <i class="fal fa-check"></i></li>
                            </ul>
                            <Link to="/contact" class="main-btn main-btn-3">Purchase Now</Link>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6 col-sm-10">
                    <div class="pricing-plan-box mt-30">
                        <div class="pricing-header">
                            
                            <div class="text-end">
                                <span class="price-wrap">
                                    <center>
                                        <span><p style={{fontSize: "48px", color: "red"}}>Premium</p></span>
                                    <div></div>
                                    </center>
                                    <span class="currency">Rs</span>
                                    <span class="price">35,000</span>
                                    <span class="price-suffix">.00</span>
                                </span>
                                <span class="pricing-limit">Per Month</span>
                            </div>
                        </div>
                        <div class="pricing-content">
                            <ul class="clearfix">
                               
                                <li>15 Poster Design <i class="fal fa-check"></i></li>
                                <li>12 Reels <i class="fal fa-check"></i></li>
                                <li>Product Shoot<i class="fal fa-check"></i></li>
                            </ul>
                            <Link to="/contact" class="main-btn main-btn-3">Purchase Now</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="pricing-section section-gap">
        <div class="container">
            <div class="section-title text-center mb-30">
                <span class="title-tag1">Website Plans</span>
                <h2 class="title1">Price & Plans</h2>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-4 col-md-6 col-sm-10">
                    <div class="pricing-plan-box mt-30">
                        <div class="pricing-header">
                            
                            <div class="text-end">
                                <span class="price-wrap">
                                    <center>
                                        <span><p style={{fontSize: "42px"}}>Static</p></span>
                                    <div></div>
                                    </center>
                                    <span class="currency">Rs</span>
                                    <span class="price">15,000</span>
                                    <span class="price-suffix">.00</span>
                                </span>
                            </div>
                        </div>
                        <div class="pricing-content">
                            <ul class="clearfix">
                                <li>5 Pages<i class="fal fa-check"></i></li>
                                <li>Social media Intergration <i class="fal fa-check"></i></li>
                                <li>Whatsapp Intergration<i class="fal fa-check"></i></li>
                                <li>.com Domain for 1 year<i class="fal fa-check"></i></li>
                                <li>Hosting for 1 year<i class="fal fa-check"></i></li>
                                
                            </ul>
                            <Link to="/contact" class="main-btn main-btn-3">Purchase Now</Link>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6 col-sm-10">
                    <div class="pricing-plan-box featured-box mt-30">
                        <div class="pricing-header">
                            
                            <div class="text-end">
                                <span class="price-wrap">
                                    <center>
                                        <span><p style={{fontSize: "42px"}}>Semi-Dynamic</p></span>
                                    <div></div>
                                    </center>
                                    <span class="currency">Rs</span>
                                    <span class="price">25,000</span>
                                    <span class="price-suffix">.00</span>
                                </span>
                                
                            </div>
                        </div>
                        <div class="pricing-content">
                            <ul class="clearfix">
                                <li>upto 10 Pages <i class="fal fa-check"></i></li>
                                <li>Admin Page<i class="fal fa-check"></i></li>
                                <li>Social media Intergration <i class="fal fa-check"></i></li>
                                <li>Whatsapp Intergration <i class="fal fa-check"></i></li>
                                <li>.com Domain for 1 year<i class="fal fa-check"></i></li>
                                <li>Hosting for 1 year<i class="fal fa-check"></i></li>
                            </ul>
                            <Link to="/contact" class="main-btn main-btn-3">Purchase Now</Link>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6 col-sm-10">
                    <div class="pricing-plan-box mt-30">
                        <div class="pricing-header">
                            
                            <div class="text-end">
                                <span class="price-wrap">
                                    <center>
                                        <span><p style={{fontSize: "42px"}}>Ecommerce</p></span>
                                    <div></div>
                                    </center>
                                    <span class="currency">Rs</span>
                                    <span class="price">35,000</span>
                                    <span class="price-suffix">.00</span>
                                </span>
                                
                            </div>
                        </div>
                        <div class="pricing-content">
                            <ul class="clearfix">
                                <li>Customiziable<i class="fal fa-check"></i></li>
                                <li>Payment Intergration<i class="fal fa-check"></i></li>
                                <li>Social media Intergration <i class="fal fa-check"></i></li>
                                <li>.com Domain for 1 year<i class="fal fa-check"></i></li>
                                <li>Hosting for 1 year<i class="fal fa-check"></i></li>
                            </ul>
                            <Link to="/contact" class="main-btn main-btn-3">Purchase Now</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
   <Footer></Footer>
</Fragment>
    )
}
export default Price;